import TFormatInput from './index.vue'

TFormatInput.install = Vue => {
  Vue.component(TFormatInput.name, TFormatInput)
}

export default TFormatInput



// WEBPACK FOOTER //
// ./src/module/format-input/index.js